import React from "react"

const useLeaveOverlay = (showLeave: boolean, defaultStatus: boolean) => {
  const [showLeaveOverlay, setShowLeaveOverlay] = React.useState(
    showLeave && defaultStatus
  )

  return { showLeaveOverlay, setShowLeaveOverlay }
}

export default useLeaveOverlay
